// Booking.js
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function Booking() {
  const { id } = useParams(); // Paperbell package ID

  useEffect(() => {
    const scriptId = "paperbellCalendarEmbedScript";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://js.paperbell.com/calendar-embed.js";
      script.onload = () => {
        if (window.Paperbell) {
          window.Paperbell.render();
        }
      };
      document.head.appendChild(script);
    } else {
      const waitAndRender = () => {
        const container = document.querySelector(".paperbell-calendar-container");
        if (container && window.Paperbell) {
          window.Paperbell.render();
        } else {
          setTimeout(waitAndRender, 100);
        }
      };
      waitAndRender();
    }
  }, [id]);

  const handleManualRender = () => {
   window.location.reload();
  };

  return (
    <div style={{ maxWidth: "800px", margin: "4rem auto", padding: "1rem", textAlign: "center" }}>
    

      <div
        className="paperbell-calendar-container"
        data-package-id={id}
        style={{ width: "100%", marginTop: "2rem" }}
      ></div>

      {/* Manual refresh button */}
      <button
        onClick={handleManualRender}
        style={{
          marginTop: "2rem",
          padding: "0.75rem 1.5rem",
          background: "#456882",
          color: "#fafafa",
          border: "none",
          borderRadius: "20px",
          cursor: "pointer",
          fontSize: "1rem",
        }}
      >
        Not seeing the form? Click here to refresh
      </button>
    </div>
  );
}
